import lInvert from "lodash/invert";

export default {
  detailType: {
    1: "简介",
    2: "详情",
    3: "亮点",
    4: "一句话简介",
    5: "购买须知",
  },
  FeedTypes: {
    FEED_TYPE_REVIEW: 1,
    FEED_TYPE_WANT_WATCH: 2,
    FEED_TYPE_TWEET: 3,
    FEED_TYPE_TRANSFER: 4,
    FEED_TYPE_ARTICLE: 5,
    FEED_TYPE_OPERATION: 11,
    FEED_TYPE_RECOMMEND: 12,
  },
  ReceiveType: {
    1: "快递配送",
    2: "上门自取",
    3: "现场取票",
    4: "电子票",
    5: "电子票",
  },
  OrderStatus: {
    1: "订单创建成功",
    2: "订单待支付",
    3: "订单待出票",
    4: "订单待确认收票",
    5: "订单已完成",
    6: "订单已关闭",
    7: "订单已退款",
  },
  PaymentType: {
    1: "Alipay",
    2: "Wechat",
  },
  ShopType: {
    1: "Personal",
    2: "Merchant",
  },
  EventStatus: {
    1: "Invalid",
    2: "Valid",
    3: "StopSale",
    4: "Expired",
  },
  TicketsFlag: {
    1: "None",
    2: "Less",
    3: "Normal",
    4: "Enough",
  },
  activityStatus: {
    1: "售票中",
    2: "已停售",
    3: "已过期",
    4: "预售中",
    5: "已退款",
  },
  activeCities: {
    1: "上海",
    2: "北京",
    4: "广州",
    9: "重庆",
  },
  ticketsStatus: {
    1: "", // 有效
    2: "已消费",
    3: "已作废",
  },
  category: {
    // 回头这里的顺序由后端控制
    0: "全部",
    1: "演唱会",
    2: "话剧歌剧",
    5: "休闲展览",
    8: "体育赛事",
    9: "旅游玩乐",
    3: "音乐会",
    4: "儿童亲子",
    6: "舞蹈芭蕾",
    7: "戏曲综艺",
    10: "潮生活",
  },
  categoryIds: [0, 1, 8, 2, 3, 7, 4, 5, 6],
  wesaiCategories: [
    // '全部分类',
    // '体育赛事',
    // '演唱会',
    "话剧歌剧",
    "音乐会",
    "儿童亲子",
    "休闲展览",
    "舞蹈芭蕾",
    "戏曲综艺",
  ],
  categoryId: {
    全部: 0,
    全部分类: 0,
    演唱会: 1,
    话剧歌剧: 2,
    休闲展览: 5,
    体育赛事: 8,
    旅游玩乐: 9,
    音乐会: 3,
    儿童亲子: 4,
    舞蹈芭蕾: 6,
    戏曲综艺: 7,
    潮生活: 10,
  },
  EVENT_STATUS: {
    DELETED: 0,
    ON_SALE: 1,
    STOP_SALE: 2,
    EXPIRED: 3,
    WEIPIAO: 5,
  },
  DeliverType: {
    NormalETicket: 4,
    EPass: 5,
  },
};

export const DeliverType = {
  1: "deliver",
  2: "selfget",
  3: "onsite",
  4: "eticket",
  5: "eticket-epass",
};

export const DeliverTypeByName = lInvert(DeliverType);

export const OrderStatusArr = [
  { key: 0, value: "全部" },
  { key: 1, value: "待付款" },
  { key: 2, value: "待出票" },
  { key: 3, value: "待完成" },
];

export const OrderTypeTabs = [
  { key: 0, value: "演出" },
  { key: 1, value: "商品" },
];

export const OrderType = {
  normal: 1,
  pinTuan: 2,
  snapUp: 5,
  seekTicket: 6,
};

export const OrderTypeCN = {
  1: "普通订单",
  2: "拼团订单",
  5: "抢票订单",
  6: "求票订单",
};

//
export const SubjectType = {
  unifiedOrder: 9,
  speedPack: 7,
  plusMember: 6,
  seekTicket: 11,
};

export const SeekOrderStatus = {
  //求票订单
  WAIT_PAY: 0, //待支付
  WAIT_TAKE_ORDER: 1, //已支付定金,待接/派单
  TAKE_ORDER: 2, //已支付订单,已接/派单
  BALANCE_PAYED: 3, //已支付尾款
  GETTING_TICKETS: 4, //用户待收货
  FINISHED: 5, //已完成
  CLOSED: 6, //已关闭
  REFUNDED: 7, //已退款
  BALANCE_PAY_TIMEOUT: 8, //尾款支付超时
};

export const DiscountTypes = [
  {
    id: 1,
    name: "立减",
  },
  {
    id: 2,
    name: "折扣",
  },
  {
    id: 3,
    name: "返券",
  },
  {
    id: 5,
    name: "动态折扣",
  },
];

export const couponsStatus = [
  { key: 1, value: "待使用" },
  { key: 2, value: "已使用" },
  { key: 0, value: "已过期" },
];



// WEBPACK FOOTER //
// ./src/mods/enums.js